export const promotionsTheMiniSuites = [
  {
    title: "6 Christmas Afternoon Tea Buffet",
    description:
      "Spend Christmas afternoon at Lobby Lounge and indulge in our afternoon tea buffet.",
    date: "25 Dec 2024",
    image: "/promotions/1.png",
    url: "https://www.theminisuites.com/",
  },
  {
    title: "Shangri-La E-Boutique Spa Vouchers",
    description:
      "Treat yourself to a soothing massage with our exclusive spa vouchers.",
    date: "02 Dec 2024 - 31 Jan 2025",
    image: "/promotions/2.png",
    url: "https://www.theminisuites.com/",
  },
  {
    title: "Executive Essentials",
    description:
      "Enjoy a luxurious 5-day stay with exclusive savings on premium rooms and gourmet dining.",
    image: "/promotions/3.png",
    url: "https://www.theminisuites.com/",
  },
  {
    title: "Indulge in Decadence",
    description:
      "Treat yourself or someone special to luxurious sweets with vouchers from our patisserie.",
    image: "/promotions/4.png",
    url: "https://www.theminisuites.com/",
  },
];
